export default __webpack_public_path__ + "static/bg_mystic-151c86e541dfa9af040bc16d5701a95b.png";